"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = void 0;
exports.version = '0.9.8';
//# sourceMappingURL=version.js.map